<template>
    <div>
        <v-app-bar app
                   absolute
                   shrink-on-scroll
                   prominent
                   scroll-target="#scrolling-techniques"
                   color="accent"
                   :class="'fancyImage' + rand + ' d-print-none'"
                   height="105">
            <v-toolbar-title style="position:absolute; top: 5px;" class="pt-0">
                <router-link to="/" aria-label="Home">
                    <span style="display:none;">Home</span>
                    <picture>
                        <source srcset="https://lawmakerdocuments.blob.core.usgovcloudapi.net/photos/logoshape.webp" type="image/webp">
                        <source srcset="https://lawmakerdocuments.blob.core.usgovcloudapi.net/photos/logoshape.png" type="image/png">
                        <img src="https://lawmakerdocuments.blob.core.usgovcloudapi.net/photos/logoshape.webp" alt="Logo of the South Dakota Legislature’s Legislative Research Council. The design features the outline of the state of South Dakota, centered with the words ‘South Dakota Legislature’ in bold and ‘Legislative Research Council’ below in smaller type. Above the state outline is the silhouette of the South Dakota State Capitol dome, and below the outline is a small geometric diamond motif in green and red." height="100.069px" width="119.988px" style="min-width:120px; max-width:120px;">
                    </picture>
                </router-link>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <span style="color:white;font-size:12px;" v-if="Environment != 'Production'">{{ Environment }}</span>
            <v-spacer></v-spacer>
            <v-layout row style="margin-top: -10px; margin-right: -10px; flex-wrap: wrap">
                <v-flex v-if="!$vuetify.breakpoint.mobile" xs12 class="d-flex justify-end align-end ma-0 pa-0">
                    <div class="hidden-md-and-down" style="background-color: #757575;">
                        <v-menu open-on-hover offset-y v-for="x in FullMenu" :key="x.Name" class="hidden-md-and-down align-end" fixed>
                            <template v-slot:activator="{ on }">
                                <span class="pa-0 ma-0">
                                    <v-btn color="grey darken-1"
                                           tile
                                           depressed
                                           dark
                                           class="px-2 ml-1"
                                           v-on="on"
                                           :href="(x.SubMenu && x.SubMenu.length == 0) ? x.Route : null">
                                        <span style="font-family:Iskoola Pota;font-size:12.5px;">{{x.Name}}</span>
                                    </v-btn>
                                    <v-divider inset
                                               class="ma-0 pa-0"
                                               style="height:20px;width:2px; color:white"
                                               color="white"
                                               vertical></v-divider>
                                </span>
                            </template>
                            <v-list v-if="x.SubMenu && x.SubMenu.length > 0">
                                <template v-for="(subItem, index) in x.SubMenu">
                                    <v-list-item v-if="subItem && subItem.Route && (subItem.Route.toLowerCase().startsWith('https:') || subItem && subItem.Route && subItem.Route.toLowerCase().includes('/api/'))" :key="index" rel="noopener" :href="subItem.Route" @click="">
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <p class="text-wrap">
                                                    <span style="font-family:Iskoola Pota">{{ subItem.Name }}</span>
                                                    <span v-if="subItem.Route.includes('.pdf')"><sup>(PDF)</sup></span>
                                                    <span v-else-if="subItem.Route.endsWith('.csv')"><sup>(CSV)</sup></span>
                                                    <span v-else-if="subItem.Route.endsWith('.xls')"><sup>(XLS)</sup></span>
                                                    <span v-else-if="subItem.Route.endsWith('.xlsx')"><sup>(XLSX)</sup></span>
                                                    <span v-else-if="subItem.Route.endsWith('.doc')"><sup>(DOC)</sup></span>
                                                    <span v-else-if="subItem.Route.endsWith('.docx')"><sup>(DOCX)</sup></span>
                                                </p>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-else :key="index" :to="subItem.Route" @click="">
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <p class="text-wrap">
                                                    <span style="font-family:Iskoola Pota">{{ subItem.Name }}</span>
                                                    <span v-if="subItem.Route.includes('.pdf')"><sup>(PDF)</sup></span>
                                                    <span v-else-if="subItem.Route.endsWith('.csv')"><sup>(CSV)</sup></span>
                                                    <span v-else-if="subItem.Route.endsWith('.xls')"><sup>(XLS)</sup></span>
                                                    <span v-else-if="subItem.Route.endsWith('.xlsx')"><sup>(XLSX)</sup></span>
                                                    <span v-else-if="subItem.Route.endsWith('.doc')"><sup>(DOC)</sup></span>
                                                    <span v-else-if="subItem.Route.endsWith('.docx')"><sup>(DOCX)</sup></span>
                                                </p>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-list>
                        </v-menu>
                    </div>
                </v-flex>
                <v-flex v-if="$vuetify.breakpoint.mobile" xs12 class="hidden-lg-and-up d-flex pr-3 justify-end">
                    <v-btn color="grey darken-1"
                           aria-label="Menu"
                           dark
                           @click.stop="drawer = !drawer">
                        <v-icon>{{mdimenu}}</v-icon>
                    </v-btn>
                </v-flex>
                <v-flex v-else-if="!$vuetify.breakpoint.mobile" class="hidden-md-and-down d-flex flex-row-reverse pt-2">
                    <v-speed-dial v-model="SearchBar"
                                  direction="left"
                                  right
                                  transition="slide-s-transition">
                        <template v-slot:activator>
                            <v-btn color="grey darken-1"
                                   dark
                                   small
                                   bottom
                                   right
                                   aria-label="Search"
                                   @click="focusToGoogleSearch()"
                                   fab>
                                <span style="display:none">Search</span>
                                <v-icon>{{search}}</v-icon>
                            </v-btn>
                        </template>
                        <v-card @click.stop="">
                            <v-card-text style="width:400px;">
                                <v-text-field label="Go To:(1,1-1, 01:15) or Google Search"
                                              ref="googleSearch"
                                              clearable
                                              v-model.trim="SearchText"
                                              v-on:keyup.enter="searchGoogle">
                                    <template v-slot:append>
                                        <v-btn small style="margin: 0px" icon @click="searchGoogle">
                                            <v-icon>{{search}}</v-icon>
                                        </v-btn>
                                    </template>
                                </v-text-field>

                            </v-card-text>
                        </v-card>
                    </v-speed-dial>
                </v-flex>
            </v-layout>
        </v-app-bar>
        <v-navigation-drawer v-if="$vuetify.breakpoint.mobile" v-model="drawer"
                             absolute
                             class="d-print-none"
                             temporary>
            <v-text-field label="Google Search"
                          clearable
                          v-model="SearchText"
                          v-on:keyup.enter="searchGoogle"
                          @click:append="searchGoogle">
                <template v-slot:append>
                    <v-btn small style="margin: 0px" icon @click="searchGoogle" aria-label="search">
                        <v-icon aria-label="search">{{search}}</v-icon>
                    </v-btn>
                </template>
            </v-text-field>
            <v-list>
                <v-list-group v-for="item in MenuItemsNoMylrc"
                              :key="item.Name"
                              v-model="item.active"
                              no-action>
                    <template v-slot:activator v-if="item.SubMenu && item.SubMenu.length > 0">
                        <v-list-item-content>
                            <v-list-item-title style="font-family:Iskoola Pota">
                                <p class="text-wrap">
                                    {{item.Name}}
                                </p>
                            </v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <template v-for="(subItem, index) in item.SubMenu">
                        <v-list-item v-if="subItem && subItem.Route && (subItem.Route.toLowerCase().startsWith('https:') || subItem && subItem.Route && subItem.Route.toLowerCase().includes('/api/'))" :key="index"
                                     rel="noopener" :href="subItem.Route"
                                     @click="">
                            <v-list-item-content>
                                <v-list-item-title>
                                    <p class="text-wrap">
                                        <span style="font-family:Iskoola Pota">{{ subItem.Name }}</span>
                                        <span v-if="subItem.Route.endsWith('.pdf')"><sup>(PDF)</sup></span>
                                        <span v-else-if="subItem.Route.endsWith('.csv')"><sup>(CSV)</sup></span>
                                        <span v-else-if="subItem.Route.endsWith('.xls')"><sup>(XLS)</sup></span>
                                        <span v-else-if="subItem.Route.endsWith('.xlsx')"><sup>(XLSX)</sup></span>
                                        <span v-else-if="subItem.Route.endsWith('.doc')"><sup>(DOC)</sup></span>
                                        <span v-else-if="subItem.Route.endsWith('.docx')"><sup>(DOCX)</sup></span>
                                    </p>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-else :key="index"
                                     :to="subItem.Route"
                                     @click="">
                            <v-list-item-content>
                                <v-list-item-title>
                                    <p class="text-wrap">
                                        <span style="font-family:Iskoola Pota">{{ subItem.Name }}</span>
                                        <span v-if="subItem.Route.endsWith('.pdf')"><sup>(PDF)</sup></span>
                                        <span v-else-if="subItem.Route.endsWith('.csv')"><sup>(CSV)</sup></span>
                                        <span v-else-if="subItem.Route.endsWith('.xls')"><sup>(XLS)</sup></span>
                                        <span v-else-if="subItem.Route.endsWith('.xlsx')"><sup>(XLSX)</sup></span>
                                        <span v-else-if="subItem.Route.endsWith('.doc')"><sup>(DOC)</sup></span>
                                        <span v-else-if="subItem.Route.endsWith('.docx')"><sup>(DOCX)</sup></span>
                                    </p>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                </v-list-group>
                <v-list-item>
                    <v-list-item-content>
                        <v-btn left block rel="noopener" :href="$MyLRCUrl.value" text class="pl-0" style="font-family:Iskoola Pota; justify-content:start;">MyLRC+</v-btn>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

        </v-navigation-drawer>
        <v-dialog v-model="googleSitewideResults">
            <v-toolbar>
                <v-spacer></v-spacer>
                <v-btn text @click="googleSitewideResults = false">
                    X
                </v-btn>
            </v-toolbar>
            <iframe :src="searchURL" height="800"></iframe>
        </v-dialog>
    </div>
</template>
<script>
    import { mdiMenu } from '@mdi/js';
    import { mdiMagnify } from '@mdi/js';
    export default {
        name: 'AppBar',
        data: function ()
        {
            return {
                search: mdiMagnify,
                mdimenu: mdiMenu,
                loading: false,
                drawer: false,
                rand: 1,
                SearchBar: false,
                SearchText: null,
                googleSitewideResults: false,
                searchURL: '',
                Sessions: [],
                FullMenu: [
                    {
                        "SubMenu": [
                            { "SubMenu": null, "Name": "Legislator Contacts", "Route": "/Legislators/Contacts/64", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Find My Legislators", "Route": "/Legislators/Find", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "2022 Legislator Listing", "Route": "/Legislators/Listing/64", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Historical Listing", "Route": "/Historical/Listing", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Legislator Term Limits", "Route": "https://mylrc.sdlegislature.gov/api/Documents/Resource/127115.pdf?Year=2016", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Address List", "Route": "/api/SessionMembers/64.csv", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Archived", "Route": "/Session/Archived", "Icon": null, "Expanded": false }],
                        "Name": "Legislators", "Route": null, "Icon": null, "Expanded": false
                    },
                    {
                        "SubMenu": [
                            { "SubMenu": null, "Name": "2022 Bills", "Route": "/Session/Bills/64", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "2022 Chambers/Committees", "Route": "/Session/Committees/64", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "2022 Conference Committees", "Route": "/Session/ConferenceCommittees/64", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "2022 General", "Route": "/Session/General/64", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "2022 Schedule", "Route": "/Session/Schedule", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Archived", "Route": "/Session/Archived", "Icon": null, "Expanded": false }], "Name": "Session", "Route": null, "Icon": null, "Expanded": false
                    },
                    {
                        "SubMenu": [
                            { "SubMenu": null, "Name": "2022 Committees", "Route": "/Interim/Committees/64", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "2022 Schedule", "Route": "/Interim/Schedule", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "2022 Rules of Procedure", "Route": "https://mylrc.sdlegislature.gov/api/Documents/RulesOfProcedure/72129.pdf?Year=2021", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Archived", "Route": "/Interim/Archived", "Icon": null, "Expanded": false }], "Name": "Interim", "Route": null, "Icon": null, "Expanded": false
                    },
                    {
                        "SubMenu": [
                            { "SubMenu": null, "Name": "Constitution", "Route": "/Statutes/Constitution", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Codified Laws", "Route": "/Statutes", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "2022 Session Laws", "Route": "/Statutes/Session_Laws/64", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Archived", "Route": "/Session/Archived", "Icon": null, "Expanded": false }], "Name": "Laws", "Route": null, "Icon": null, "Expanded": false
                    },
                    {
                        "SubMenu": [
                            { "SubMenu": null, "Name": "Administrative Rules List", "Route": "/Rules/Administrative", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Current Register", "Route": "https://mylrc.sdlegislature.gov/api/Documents/Register/225182.pdf?Year=2022", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Archived Registers", "Route": "/Rules/Registers/64", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Administrative Rules Manual", "Route": "/Rules/RulesManual", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Rules Review Committee", "Route": "/Interim/Committee/493", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Rules.sd.gov", "Route": "https://rules.sd.gov", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Administrative Rule Process", "Route": "https://mylrc.sdlegislature.gov/api/Documents/IssueMemo/124666.pdf?Year=2017", "Icon": null, "Expanded": false }], "Name": "Administrative Rules", "Route": null, "Icon": null, "Expanded": false
                    },
                    {
                        "SubMenu": [
                            { "SubMenu": null, "Name": "Hearing Documents", "Route": "/Budget/Documents", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Monthly Reports", "Route": "/Budget/MonthlyReport", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Budget Resources", "Route": "/Budget/Resources", "Icon": null, "Expanded": false }], "Name": "Budget", "Route": null, "Icon": null, "Expanded": false
                    },
                    {
                        "SubMenu": [
                            { "SubMenu": null, "Name": "Page Program", "Route": "/Students/Page", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Intern Program", "Route": "/Students/Intern", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Resources", "Route": "/Students/Resources", "Icon": null, "Expanded": false }], "Name": "Students", "Route": null, "Icon": null, "Expanded": false
                    },
                    {
                        "SubMenu": [
                            { "SubMenu": null, "Name": "Drafting Manual", "Route": "https://mylrc.sdlegislature.gov/api/Documents/Resource/127102.pdf?Year=2016", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Issue Memos / White Papers", "Route": "/References/IssueMemos", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Maps", "Route": "/References/Maps", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Performance Management Reports", "Route": "/References/PerformanceReports", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Program Evaluations", "Route": "/References/ProgramEvaluation", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Required Reports", "Route": "/References/RequiredReports", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Statistical Comparisons", "Route": "/References/StatisticalComparison", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "External Resources", "Route": "/References/ExternalResources", "Icon": null, "Expanded": false },
                            { "SubMenu": null, "Name": "Public Resources", "Route": "/References/PublicResources", "Icon": null, "Expanded": false }], "Name": "References", "Route": null, "Icon": null, "Expanded": false
                    },
                    {
                        "SubMenu": [], "Name": "MyLRC +", "Route": "https://mylrc.sdlegislature.gov", "Icon": null, "Expanded": false
                    }],
            }
        },
        created: function ()
        {
        },
        mounted: function ()
        {
            let maxrand = 5;
            let screenWidth;
            if (window && window.screen)
            {
                screenWidth = window.screen.width;
            } else
            {
                screenWidth = window.innerWidth || 1920;
            }

            if (screenWidth > 1920)
            {
                maxrand = 1;
            }
            this.rand = this.getRandomInt(1, maxrand);
            this.LoadData();
        },
        methods: {
            LoadData: function ()
            {
                this.loading = true;

                fetch('/api/Documents/FullMenu',
                    {
                        method: "GET",
                        credentials: "include",
                        headers: {
                            "Content-Type": "application/json"
                        },
                    })
                    .then(res =>
                    {
                        this.loading = false;
                        if (res.ok)
                            return res.json();
                        else
                            throw new Error(res.statusText);
                    })
                    .then(response =>
                    {
                        this.FullMenu = response;
                    })
                    .catch(error =>
                    {
                        throw new Error(error);
                    });
            },
            onFocus: function ()
            {
                this.SearchBar = true;
            },
            focusToGoogleSearch: function ()
            {
                if (!this.SearchBar)
                {
                    this.$nextTick(() =>
                    {
                        setTimeout(() =>
                        {
                            if (this && this.$refs && this.$refs["googleSearch"])
                            {
                                this.$refs["googleSearch"].$refs.input.focus();
                            }
                        });
                    });
                }
            },
            searchGoogle(item)
            {
                let UpperSearchText = ((this.SearchText || "").toUpperCase() || "");
                let match = UpperSearchText.match(/^\s*(?:SB|HB|HC|SC|SCR|HCR|SJR|HJR|SRD|HRD){0,1}\s*(\d{1,4})\s*$/);

                if (match)
                {
                    fetch('/api/Bills/ByBillNumber/' + match[1], { method: "GET" })
                        .then(res =>
                        {
                            if (res.ok)
                                return res.json();
                            else
                                return Promise.reject();
                        })
                        .then(r =>
                        {
                            this.SearchText = "";
                            this.SearchBar = false;
                            this.$router.push('/Session/Bill/' + r);
                        })
                        .catch(() =>
                        {
                            this.searchGooglePart2();
                        });
                }
                else
                {
                    this.searchGooglePart2();
                }
            },
            searchGooglePart2()
            {
                const StatuteRegex = /^\d{1,2}[A-Za-z]{0,1}[-](\d{1,2}[A-Za-z]{0,1})[-]?([0-9A-Za-z]*)?\s*(\([0-9A-Za-z]+\))?(\.[0-9A-Za-z]+)?/g;
                const ConstitutionRegex = /^\d{1,2}[A-Za-z]{0,1}[-](\d{1,2}[A-Za-z]{0,1})[-]?([0-9A-Za-z]*)?\s*(\([0-9A-Za-z]+\))?(\.[0-9A-Za-z]+)?/g;
                const AdministrativeRegex = /^\d{1,2}:(\d{1,2})(?::(\d{1,2})([a-zA-Z])?)?(?:\.(\d{1,2}))?(?::(\d{1,2})([a-zA-Z])?)?(?:\.(\d{1,2}))?/g;

                let UpperSearchText = ((this.SearchText || "").toUpperCase() || "");

                if (UpperSearchText.match(StatuteRegex))
                {
                    this.$router.push('/Statutes/' + this.SearchText);
                }
                else if (UpperSearchText.match(AdministrativeRegex))
                {
                    this.$router.push('/Rules/Administrative/' + this.SearchText);
                }
                else
                {
                    this.searchURL = '/SearchResults.html?q=' + this.SearchText;
                    this.googleSitewideResults = true;
                }

                this.SearchText = "";
                this.SearchBar = false;
            },
            getRandomInt(min, max)
            {
                return Math.floor(Math.random() * (max - min + 1)) + min;
            },
        },
        watch: {
        },
        computed:
        {
            Environment()
            {
                return this.$Environment.value;
            },
            MenuItemsNoMylrc: function ()
            {
                return this.FullMenu.filter(x => x.Name != 'MyLRC +');
            },
        },
    };
</script>

<style></style>